import React from 'react'

export const ArrowTriangleBlack = ({ ...props }): any => {
    return (
        <svg {...props} width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 5.5L0.73686 0.25L10.2631 0.250001L5.5 5.5Z" fill="#040503" />
        </svg>

    )
}
